import request from '@/utils/request'

// 数据文章列表 - 根据栏目id查询
export function contentList(params) {
  return request({
    url: '/cms/content/list' ,
    method: 'GET',
    params
  })
}


// 根据文章Id查询文章详细信息
export function getContent(params) {
  return request({
    url: '/cms/content/get' ,
    method: 'GET',
    params
  })
}